export default __webpack_public_path__ + "static/media/fig6.1f95cd08.jpg";